module.exports = "<div class=passenger-container ng-repeat=\"traveller in $ctrl.travellers track by traveller.Id\" ng-class=\"{selected: $ctrl.selected === traveller}\" ng-click=$ctrl.selectTraveller(traveller) kt-passenger-seat=traveller kt-passenger-seat-map=$ctrl.map kt-passenger-seat-flight=$ctrl.flight kt-passenger-seat-trip-details=$ctrl.tripDetails kt-passenger-seat-selected-seats=$ctrl.selectedSeats></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/passengers-seats/passengers-seats.html
// module id = 892
// module chunks = 0